import React from 'react';

import EventRegistrationButton from 'buyside/components/presentation/EventPage/EventRegistrationButton/eventRegistrationButton';
import EventRegistrationButtonSubtitle from 'buyside/components/presentation/EventPage/EventRegistrationButtonSubtitle/eventRegistrationButtonSubtitle';
import PublicRegistrationForm from 'buyside/components/presentation/EventPage/PublicRegistrationForm/publicRegistrationForm';

// import Logo from 'buyside/svgs/logo-solid.svg';

import styles from './eventHeaderStyles.scss';

const EventHeader: React.FC<{ isLoggedIn: boolean }> = ({ isLoggedIn }) => (
  <div className={styles.headerContainer}>
    <div className={styles.header}>
      <div>
        {/* <div className={styles.logo}>
          <Logo />
        </div> */}
        <div>SumZero & AlphaSense</div>
        <div>SPRING INVESTOR SUMMIT</div>
      </div>
      <div>2025</div>
    </div>
    <div className={styles.date}>
      <div>May 28, 2025</div>
      &#x2022;
      <div>NYC</div>
    </div>

    {isLoggedIn ? <EventRegistrationButton /> : <PublicRegistrationForm />}

    <EventRegistrationButtonSubtitle />
  </div>
);

export default EventHeader;
